const $ = window.jQuery;
import OkC from "shared/util/OkcApi";

Ok.IncognitoDowngrade = {
	init() {
		this.Dom = {
			modal: $("#incognitoDowngrade"),
			downgrade: $("#incognito-downgrade-opener"),
		};
		this.Dom.form = this.Dom.modal.find(".incognito-downgrade-form");
		this.Dom.comments = this.Dom.modal.find(".incognito-downgrade-comments");
		this.Dom.password = this.Dom.modal.find(".incognito-downgrade-password");
		this.Dom.type = this.Dom.modal.find(".incognito-downgrade-type");
		this.Dom.deleteBilling = this.Dom.modal.find(".incognito-downgrade-deletebilling");
		this.Dom.forgotPassword = this.Dom.modal.find(".incognito-downgrade-forgotpassword");
		this.Dom.submit = this.Dom.modal.find(".incognito-downgrade-submit");
		this.Dom.cancel = this.Dom.modal.find(".incognito-downgrade-cancel");

		this.Data = {};
		this.Data.okform = new OkForm(this.Dom.form.attr("id"));

		this.listen();
	},

	listen() {
		this.Dom.downgrade.on("tap click", this.show.bind(this));
		this.Dom.submit.on("tap click", this.downgrade.bind(this));
		this.Dom.cancel.on("tap click", this.hide.bind(this));

		this.Dom.forgotPassword.on("tap click", (ev) => {
			ev.preventDefault();
			this.sendPasswordEmail();
		});

		this.Dom.password.on("input change", (ev) => {
			this.downgradeValidate();
		});
	},

	show() {
		Modal.open(this.Dom.modal.attr("id"));
	},

	hide() {
		Modal.close();
	},

	sendPasswordEmail() {
		Settings.forgotPw(this.sendPasswordEmail_cb.bind(this));
	},

	sendPasswordEmail_cb(transport) {
		// this is a prototype ajax response, so we gotta parse JOSN
		const response = JSON.parse(transport.responseText);

		if (
			response &&
			["SUCCESS", "REQUEST_LIMIT"].indexOf(response.message) > -1
		) {
			this.setPasswordMessage("Reset email has been sent!", "success");
		} else {
			this.setPasswordMessage(
				"Password reset failed, try again later!",
				"error",
			);
		}
	},

	downgrade() {
		if (this.Dom.submit.hasClass("disabled")) {
			return false;
		}

		const valid = this.downgradeValidate(true);
		if (!valid) {
			return false;
		}

		const params = {
			password: this.Dom.password.val(),
			okc_api: 1,
			feature: 10002,
		};

		if (this.Dom.deleteBilling.prop("checked")) {
			params.deleteBillingInfo = 1;
			params.delete_info = 1;
		}

		if (this.Dom.type.val() === "paypal") {
			params.cancel = 1;
			OkC.legacy("/paypal", {
				data: params,
				success: this.downgrade_cb.bind(this),
			});
		} else {
			OkC.legacy("/downgrade", {
				data: params,
				success: this.downgrade_cb.bind(this),
			});
		}
	},

	downgrade_cb(response) {
		this.setPasswordMessage("", "");

		if (response.status === "PW_ERROR") {
			this.setPasswordMessage("Your password didn’t match.", "error");
		} else if (response.status === "SUCCESS") {
			const text = this.Dom.comments.val();

			if (text.replace(/\s/gi, "") === "") {
				window.location = "/settings?incognito_downgraded=1";
				return;
			}

			const params = {
				target: 0,
				type: "Incognito Downgrade",
				text,
				add_comment: 1,
			};

			OkC.legacy("/why", {
				data: params,
				success: () => {
					window.location = "/settings?incognito_downgraded=1";
				},
			});
		}
	},

	downgradeValidate(showMsg) {
		let valid = true;
		const pw = this.Dom.password.val();

		if (pw.length < 1) {
			valid = false;

			if (showMsg) {
				this.setPasswordMessage("Password cannot be empty", "error");
			}
		} else {
			this.setPasswordMessage("", "");
		}

		this.Dom.submit.toggleClass("disabled", !valid);
		return valid;
	},

	setPasswordMessage(message, type) {
		this.Data.okform.setMessage(this.Dom.password, message, type);
	},
};



// WEBPACK FOOTER //
// ./src/legacy/incognito/downgrade.js